import React from "react";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import WalletAccess from "../components/WalletAccess";
import CreateWalletModal from "../components/createWalletModal";
import { useState } from "react";

const ROWS = [
  ["Nombre",   (u) => `${u.name} ${u.lastName}`],
  ["Correo",   (u) => u.email],
  ["Teléfono", (u) => u.phone || "—"],
  ["País",     (u) => u.country || "—"],
  ["Verificación KYC", (u) => u.cryptopocketKycStatus === "valid" ? "✓ Verificado" : "Pendiente"],
];

export default function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [showCreateWallet, setShowCreateWallet] = useState(false);
  if (!user) return null;

  return (
    <>
      <Navbar />
      <div className="dashboard">

        {/* Wallet section */}
        <div style={{ maxWidth: 580, margin: "0 auto 28px" }}>
      
          {user.magicWalletAddress ? (
            <WalletAccess
              address={user.magicWalletAddress}
              email={user.email}
            />
          ) : (
            <div className="wallet-access-card">
              <p className="eyebrow">Mi Wallet</p>
              <p className="status-text" style={{ margin: "8px 0 14px" }}>
                Aún no tienes una wallet. Crea una gratis con tu correo para recibir
                criptomonedas directamente.
              </p>
              <button className="btn btn-primary btn-block" onClick={() => setShowCreateWallet(true)}>
                Crear mi wallet
              </button>
            </div>
          )}
        </div>

        {/* Account info */}
        <div className="profile-card">
          {ROWS.map(([label, get]) => (
            <div className="profile-row" key={label}>
              <span className="profile-label">{label}</span>
              <span className="profile-value">{get(user)}</span>
            </div>
          ))}
        </div>
      </div>

      <CreateWalletModal
        open={showCreateWallet}
        onClose={() => setShowCreateWallet(false)}
        onWalletCreated={() => { refreshUser(); setShowCreateWallet(false); }}
      />
    </>
  );
}